import { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Box,
  Tooltip,
  IconButton,
  Autocomplete,
  Checkbox,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
// import { createSalesTargetApi } from "../../app/slices/templateCreation/createSalesTargetSlice";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { ContentCopy, Delete as DeleteIcon } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { getSalesTargetApi } from "../../app/slices/salesTarget/getSalesTargetSlice";
import { createSalesTargetApi } from "../../app/slices/salesTarget/createSalesTargetSlice";
import { deleteSalesTargetApi } from "../../app/slices/salesTarget/deleteSalesTargetSlice";
import { updateSalesTargetApi } from "../../app/slices/salesTarget/updateSalesTargetSlice";

export default function SalesTarget() {
  const dispatch = useDispatch();
  const roleResponse = useSelector((state) => state.login.login.role);

  useEffect(() => {
    dispatch(getSalesTargetApi());
  }, [dispatch]);

  const sliceResponse = useSelector(
    (state) => state.getSalesTarget.getSalesTarget.data
  );
  const stateLoading = useSelector((state) => state.getSalesTarget.loading);

  const [formData, setFormData] = useState({
    region: "",
    targetAmount: "",
    month: "",
    year: "",
  });

  const [errors, setErrors] = useState({
    region: false,
    targetAmount: false,
    month: false,
    year: false,
  });

  const validateForm = () => {
    const newErrors = {
      region: !formData.region,
      targetAmount: formData.targetAmount === "",
      month: formData.month === "",
      year: formData.year === "",
    };
    setErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  // const [formData, setFormData] = useState({
  //   region: [],
  //   targetAmount: "",
  //   date: "",
  // });
  // console.log("formData: ", formData);

  // const [errors, setErrors] = useState({
  //   template_image: false,
  //   title: false,
  //   description: false,
  //   region: false,
  // });

  // const validateForm = () => {
  //   const newErrors = {
  //     region: !formData.region,
  //     targetAmount: formData.targetAmount === "",
  //     date: formData.date === "",
  //   };
  //   setErrors(newErrors);
  //   return !Object.values(newErrors).includes(true);
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        const response = await dispatch(createSalesTargetApi(formData));
        if (response.meta.requestStatus === "fulfilled") {
          Swal.fire({
            text: "Upload Successful!",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          dispatch(getSalesTargetApi());

          // Reset formData after successful submission
          setFormData({
            region: "",
            targetAmount: "",
            month: "",
            year: "",
          });

          // Manually reset the file input field to clear the file name
          document.getElementById("file-input").value = ""; // This clears the input field
        }
      } catch (error) {
        console.log("error: ", error);
      }
    }
  };
  //    ***************************************************** Edit ********************************************
  const [editState, seteditState] = useState(false);

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        const response = await dispatch(updateSalesTargetApi(formData));
        if (response.meta.requestStatus === "fulfilled") {
          Swal.fire({
            text: "Updated Successfully!",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
          });
          dispatch(getSalesTargetApi());
          // Reset formData after successful submission
          setFormData({
            region: "",
            targetAmount: "",
            month: "",
            year: "",
          });
          seteditState(false);
          // Manually reset the file input field to clear the file name
          document.getElementById("file-input").value = ""; // This clears the input field
        }
      } catch (error) {
        console.log("error: ", error);
      }
    }
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("region", {
      header: "Region",
      size: 30,
      Cell: ({ row }) => {
        const regions = row.original.region;

        // Agar regions array hai toh capitalize karke join kar denge
        if (Array.isArray(regions)) {
          return regions
            .map((region) => region.charAt(0).toUpperCase() + region.slice(1))
            .join(", ");
        }

        // Agar single string hai toh sirf capitalize karenge
        return regions
          ? regions.charAt(0).toUpperCase() + regions.slice(1)
          : "-";
      },
    }),

    columnHelper.accessor("month", {
      header: "Month",
      size: 30,
      Cell: (cell) => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        return <span>{months[cell.row.original.month]}</span>;
      },
    }),
    columnHelper.accessor("year", {
      header: "Year",
      size: 30,
      Cell: (cell) => <span>{cell.row.original.year}</span>,
    }),

    // columnHelper.accessor("date", {
    //   header: "Date",
    //   size: 30,
    //   Cell: (cell) => (
    //     <span style={{ textAlign: "center" }}>
    //       {cell.row.original.date?.split("T")[0]}
    //     </span>
    //   ),
    // }),
    columnHelper.accessor("targetAmount", {
      header: "Target Amount",
      size: 30,
      Cell: (cell) => (
        <span style={{ textAlign: "center" }}>
          {cell.row.original.targetAmount}
        </span>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <span style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </span>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <span style={{ textAlign: "center" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </span>
      ),
    }),
    // columnHelper.accessor("status", {
    //     header: "Status",
    //     size: 30,
    //     Cell: ({ cell }) => {
    //         const isActive = cell.getValue() == 1 ? true : false;
    //         const rowId = cell.row.original._id;
    //         const handleToggle = () => {
    //             handleStatusChange(rowId);
    //         };
    //         return (
    //             <Switch
    //                 checked={isActive} // checked when inactive (1)
    //                 onChange={handleToggle}
    //                 inputProps={{ "aria-label": "Status toggle" }}
    //             />
    //         );
    //     },
    // }),
  ];

  if (
    roleResponse?.TemplateCreation?.update === 1 ||
    roleResponse?.TemplateCreation?.delete === 1
  ) {
    columns.push(
      columnHelper.accessor("Actions", {
        header: "Actions",
        size: 30,
        Cell: ({ cell }) => {
          const rowId = cell.row.original._id;
          const rowData = cell.row.original;

          return (
            <Box>
              {roleResponse?.TemplateCreation?.update === 1 && (
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      seteditState(true);
                      setFormData({
                        _id: rowId,
                        region: rowData?.region || "",
                        targetAmount: rowData?.targetAmount || "",
                        month: rowData?.month || "",
                        year: rowData?.year || "",
                      });
                      document.getElementById("file-input").value = ""; // This clears the input field

                      window.scrollTo({
                        top: 0,
                        behavior: "smooth", // for smooth scrolling
                      });
                    }}
                  >
                    <EditIcon color="error" />
                  </IconButton>
                </Tooltip>
              )}
              {roleResponse?.TemplateCreation?.delete === 1 && (
                <Tooltip title="Delete">
                  <IconButton
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Are you sure ?",
                        text: "You will not be able to recover this post!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#4a2a7d",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Yes, delete it!",
                      });
                      if (result.isConfirmed) {
                        dispatch(deleteSalesTargetApi({ rowId }));
                        dispatch(getSalesTargetApi());
                        Swal.fire({
                          text: "Deleted Successful!",
                          icon: "success",
                          timer: 3000,
                          showConfirmButton: false,
                        });
                      }
                    }}
                  >
                    <DeleteIcon color="red" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      })
    );
  }

  const dataForRegionSelection = [
    { name: "Select All" },
    { name: "north" },
    { name: "west" },
    { name: "south" },
    // { name: "northwest" },
    // { name: "central" },  
  ];
  const allRegions = dataForRegionSelection.slice(1).map((r) => r.name); // skip "Select All"

  // If "Select All" is clicked → select/deselect all
  const handleRegionChange = (event, selectedValues) => {
    if (selectedValues.some((item) => item.name === "Select All")) {
      if (formData.region.length === allRegions.length) {
        // Deselect all
        setFormData({ ...formData, region: [] });
      } else {
        // Select all except "Select All"
        setFormData({ ...formData, region: allRegions });
      }
    } else {
      // Normal selection
      setFormData({
        ...formData,
        region: selectedValues.map((r) => r.name),
      });
    }
  };

  // date
  // region
  // targetAmount

  return (
    <>
      {roleResponse?.TemplateCreation?.write === 1 && (
        <Grid container spacing={3} mb={3}>
          {/* Region */}
          <Grid item xs={12} md={2}>
            <Autocomplete
              id="Region"
              name="region"
              options={[
                { name: "north" },
                { name: "west" },
                { name: "south" },
                { name: "east" },
                { name: "AFT297" },
                // { name: "northwest" },
                // { name: "central" },
              ]}
              value={formData.region ? { name: formData.region } : null}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) =>
                option.name === value.name
              }
              onChange={(event, newValue) => {
                setFormData({
                  ...formData,
                  region: newValue ? newValue.name : "",
                });
                setErrors({ ...errors, region: false });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  label="Region"
                  variant="outlined"
                  fullWidth
                  error={errors.region}
                  helperText={errors.region ? "Region is required" : ""}
                />
              )}
            />
          </Grid>

          {/* Target Amount */}
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              fullWidth
              type="number"
              label="Target Amount"
              name="targetAmount"
              value={formData.targetAmount}
              onChange={(e) =>
                setFormData({ ...formData, targetAmount: e.target.value })
              }
              onBlur={() =>
                setErrors({
                  ...errors,
                  targetAmount: formData.targetAmount === "",
                })
              }
              variant="outlined"
              error={errors.targetAmount}
              helperText={
                errors.targetAmount ? "Target Amount is required" : ""
              }
            />
          </Grid>


          <Grid item xs={12} md={2}>
            <FormControl fullWidth error={errors.month} size="small">
              <InputLabel id="month-label">Month</InputLabel>
              <Select
                labelId="month-label"
                id="month"
                value={formData.month}
                onChange={(e) =>
                  setFormData({ ...formData, month: e.target.value })
                }
                onBlur={() =>
                  setErrors({
                    ...errors,
                    month: formData.month === "",
                  })
                }
              >
                <MenuItem value="">
                  <em>Select Month</em>
                </MenuItem>
                <MenuItem value="0">January</MenuItem>
                <MenuItem value="1">February</MenuItem>
                <MenuItem value="2">March</MenuItem>
                <MenuItem value="3">April</MenuItem>
                <MenuItem value="4">May</MenuItem>
                <MenuItem value="5">June</MenuItem>
                <MenuItem value="6">July</MenuItem>
                <MenuItem value="7">August</MenuItem>
                <MenuItem value="8">September</MenuItem>
                <MenuItem value="9">October</MenuItem>
                <MenuItem value="10">November</MenuItem>
                <MenuItem value="11">December</MenuItem>
              </Select>
              {errors.month && <FormHelperText>Month is required</FormHelperText>}
            </FormControl>
          </Grid>

          {/* Year */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth error={errors.year} size="small">
              <InputLabel id="year-label">Year</InputLabel>
              <Select
                labelId="year-label"
                id="year"
                value={formData.year}
                onChange={(e) =>
                  setFormData({ ...formData, year: e.target.value })
                }
                onBlur={() =>
                  setErrors({
                    ...errors,
                    year: formData.year === "",
                  })
                }
              >
                <MenuItem value="">
                  <em>Select Year</em>
                </MenuItem>
                <MenuItem value="2023">2023</MenuItem>
                <MenuItem value="2024">2024</MenuItem>
                <MenuItem value="2025">2025</MenuItem>
                <MenuItem value="2026">2026</MenuItem>
                <MenuItem value="2027">2027</MenuItem>
              </Select>
              {errors.year && <FormHelperText>Year is required</FormHelperText>}
            </FormControl>
          </Grid>

          {/* BTN== */}
          {/* <Grid item sx={12} md={2} spacing={3} gap={2}> */}
          {!editState ? (
            <Grid item xs={12} md={2}>
              <Button
                size="medium"
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                sx={{
                  transition: "transform 0.5s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.01)",
                  },
                }}
              >
                Submit
              </Button>
            </Grid>
          ) : (
            <>
              <Grid item xs={12} md={2}>
                <Button
                  fullWidth
                  size="medium"
                  variant="contained"
                  color="primary"
                  onClick={handleUpdate}
                  sx={{
                    transition: "transform 0.5s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  Update
                </Button>
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  fullWidth
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    seteditState(false);
                    setFormData({
                      region: "",
                      targetAmount: "",
                      date: "",
                    });
                    document.getElementById("file-input").value = ""; // This clears the input field
                  }}
                  sx={{
                    backgroundColor: "#bc2020 !important",
                    transition: "transform 0.5s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.05)",
                      backgroundColor: "#ca2727",
                    },
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            </>
          )}
          {/* </Grid> */}
        </Grid >
      )
      }

      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="SalesTarget"
      />
    </>
  );
}
